import React from 'react';

import type { Section } from '../../../../../models';
import { SEPARATE_HEATING_CHARGE } from '../../../../../constants';
import UtilitiesOwnRentalPropertyAnnualCosts from '../../Utilities/UtilitiesEstimatedAnnualCost/UtilitiesOwnRentalPropertyAnnualCosts';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function SeparateHeatingChargeOwnRentalPropertyAnnualCosts({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesOwnRentalPropertyAnnualCosts
      section={section}
      setSectionValues={setSectionValues}
      annualCostsField={SEPARATE_HEATING_CHARGE.FIELD_NAME.ANNUAL_COSTS}
      utilityName="Heating"
      utilityOwnRentalPropertyYesField={SEPARATE_HEATING_CHARGE.FIELD_NAME.OWN_PROPERTY_YES}
      utilityOwnRentalPropertyNoField={SEPARATE_HEATING_CHARGE.FIELD_NAME.OWN_PROPERTY_NO}
      knowAnnualCostsSimilarRentalUnitField={SEPARATE_HEATING_CHARGE.FIELD_NAME.KNOW_ANNUAL_COSTS_SIMILAR_RENTAL_UNIT}
    />
  );
}

export default SeparateHeatingChargeOwnRentalPropertyAnnualCosts;
